import React, { useState } from "react";
import {
  View,
  Text,
  TextInput,
  Dimensions,
  TouchableOpacity,
  StyleSheet,
} from "react-native";
import { Ionicons, FontAwesome } from "@expo/vector-icons";
const { width, height } = Dimensions.get("window");
export default function textInputCountriesAdd({
  Subject,
  secureTextEntry,
  plus,
  onChangeText,
  maxLength,
  defaultValue,
  onPress,
  alerts,
  style,
}) {
  const [hidepass, setHidepass] = useState(true);
  return (
    <View>
      <Text
        style={[
          width >= 1280 ? styles.textSubject : stylesResponsive.textSubject,
          {
            ...style,
          },
        ]}
      >
        {Subject}
      </Text>
      <View style={styles.viewTextInput}>
        <TextInput
          defaultValue={defaultValue}
          maxLength={maxLength}
          onChangeText={onChangeText}
          secureTextEntry={secureTextEntry && hidepass}
          style={[styles.textDetail, { ...style }]}
        />

        {plus ? (
          <TouchableOpacity onPress={onPress} style={styles.button}>
            <FontAwesome
              name="plus"
              size={width >= 1280 ? 35 : 30}
              color="#2B6AB1"
            />
          </TouchableOpacity>
        ) : (
          ""
        )}
        {secureTextEntry ? (
          <TouchableOpacity
            onPress={() => {
              setHidepass((val) => !val);
            }}
            style={styles.button}
          >
            <Ionicons
              name={hidepass ? "eye" : "eye-off"}
              size={width >= 1280 ? 35 : 30}
              color="#2B6AB1"
            />
          </TouchableOpacity>
        ) : (
          ""
        )}
      </View>
      {alerts && (
        <Text
          style={[
            width >= 1280 ? styles.textSubject : stylesResponsive.textSubject,
            {
              color: "#ff0000",
            },
          ]}
        >
          {"password length >= 6"}
        </Text>
      )}
    </View>
  );
}
const styles = StyleSheet.create({
  textSubject: {
    fontSize: 20,
    fontFamily: "Prompt",
    color: "#2B6AB1",
    marginHorizontal: width * 0.05,
    marginTop: 20,
  },
  textDetail: {
    width: width * 0.7,
    height: 40,
    paddingHorizontal: 20,
    borderBottomWidth: 1,
    borderBottomColor: "#2B6AB1",
    color: "#2B6AB1",
    fontFamily: "Prompt",
  },
  button: {
    marginLeft: -45,
    backgroundColor: "#FFFFFF",
    height: 35,
  },
  viewTextInput: {
    flexDirection: "row",
    marginHorizontal: width * 0.045,
    alignItems: "center",
  },
});
const stylesResponsive = StyleSheet.create({
  textSubject: {
    fontSize: 16,
    fontFamily: "Prompt",
    color: "#2B6AB1",
    marginHorizontal: width * 0.05,
    marginTop: 20,
  },
});
